// Libs
import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { browserHistory } from "react-router";
import { useTranslation } from "react-i18next";

// Components
import Plans from "../../components/Plans";
import ModalConductor from "../../components/_Shared/ModalConductor";
// import { Button } from "../spocketUI";

// Action
import { verify } from "../../actions";

// Images
// import closeIcon from "../images/close-icon.svg";

// Style
import {
  Page,
  Title,
  Subtitle,
  Container
} from "./UpgradeStyle";

const Upgrade = ({
  verify,
  currentModal,
  allPlans,
  annualToggleIsChecked,
  ...props
}) => {
  const { t } = useTranslation();
  useEffect(() => verify(), []);
  return (
    <Container fullScreen={allPlans.length > 0 ? false : true}>
      <Page>
        <ModalConductor currentModal={currentModal} />

        {/* {allPlans.length > 0 && (
          <CloseIcon
            src={closeIcon}
            alt="close"
            onClick={() => browserHistory.push("/search")}
          />
        )} */}

        {allPlans.length > 0 && (
          <Fragment>
            <Title>
              {annualToggleIsChecked ? (
                <span>{t("Upgrade.Title.AnnualToggled")}</span>
              ) : (
                <span>{t("Upgrade.Title.MonthlyToggled")}</span>
              )}
            </Title>
            <Subtitle>{t("Upgrade.Subtitle")}</Subtitle>
          </Fragment>
        )}

        <div>
          <Plans {...props} />
        </div>

        {/* <Footer className="UpgradePage__footer">
          {allPlans.length > 0 && (
            <Button
              variant="basicBig"
              onClick={() => browserHistory.push("/search")}
            >
              {t("Upgrade.Button")}
            </Button>
          )}
        </Footer> */}
      </Page>
    </Container>
  );
};

function mapStateToProps(state) {
  return {
    currentModal: state.ui.currentModal,
    allPlans: state.store.plans.allPlans || [],
    annualToggleIsChecked: state.upgrade.annualIsChecked
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ verify }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Upgrade);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/Upgrade.js